/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Offerdetail_Reviews_Editedtimes2Inputs */

const id_offerdetail_reviews_editedtimes2 = /** @type {(inputs: Offerdetail_Reviews_Editedtimes2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Diedit ${i?.count} kali`)
};

const ms_offerdetail_reviews_editedtimes2 = /** @type {(inputs: Offerdetail_Reviews_Editedtimes2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Disunting ${i?.count} kali`)
};

const da_offerdetail_reviews_editedtimes2 = /** @type {(inputs: Offerdetail_Reviews_Editedtimes2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Redigeret ${i?.count} gange`)
};

const de_offerdetail_reviews_editedtimes2 = /** @type {(inputs: Offerdetail_Reviews_Editedtimes2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Mal bearbeitet`)
};

const en_us2_offerdetail_reviews_editedtimes2 = /** @type {(inputs: Offerdetail_Reviews_Editedtimes2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Edited ${i?.count} times`)
};

const es_es2_offerdetail_reviews_editedtimes2 = /** @type {(inputs: Offerdetail_Reviews_Editedtimes2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Editado ${i?.count} veces`)
};

const es_mx2_offerdetail_reviews_editedtimes2 = /** @type {(inputs: Offerdetail_Reviews_Editedtimes2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Editado ${i?.count} veces`)
};

const fil_offerdetail_reviews_editedtimes2 = /** @type {(inputs: Offerdetail_Reviews_Editedtimes2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Na-edit ${i?.count} beses`)
};

const fr_offerdetail_reviews_editedtimes2 = /** @type {(inputs: Offerdetail_Reviews_Editedtimes2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Modifié ${i?.count} fois`)
};

const it_offerdetail_reviews_editedtimes2 = /** @type {(inputs: Offerdetail_Reviews_Editedtimes2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Modificato ${i?.count} volte`)
};

const hu_offerdetail_reviews_editedtimes2 = /** @type {(inputs: Offerdetail_Reviews_Editedtimes2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Szerkesztve ${i?.count} alkalommal`)
};

const nl_offerdetail_reviews_editedtimes2 = /** @type {(inputs: Offerdetail_Reviews_Editedtimes2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} keer bewerkt`)
};

const no_offerdetail_reviews_editedtimes2 = /** @type {(inputs: Offerdetail_Reviews_Editedtimes2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Redigert ${i?.count} ganger`)
};

const pl_offerdetail_reviews_editedtimes2 = /** @type {(inputs: Offerdetail_Reviews_Editedtimes2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Edytowane ${i?.count} razy`)
};

const pt_br2_offerdetail_reviews_editedtimes2 = /** @type {(inputs: Offerdetail_Reviews_Editedtimes2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Editado ${i?.count} vezes`)
};

const pt_offerdetail_reviews_editedtimes2 = /** @type {(inputs: Offerdetail_Reviews_Editedtimes2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Editado ${i?.count} vezes`)
};

const ro_offerdetail_reviews_editedtimes2 = /** @type {(inputs: Offerdetail_Reviews_Editedtimes2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Editat de ${i?.count} ori`)
};

const fi_offerdetail_reviews_editedtimes2 = /** @type {(inputs: Offerdetail_Reviews_Editedtimes2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Muokattu ${i?.count} kertaa`)
};

const sv_offerdetail_reviews_editedtimes2 = /** @type {(inputs: Offerdetail_Reviews_Editedtimes2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Redigerad ${i?.count} gånger`)
};

const vi_offerdetail_reviews_editedtimes2 = /** @type {(inputs: Offerdetail_Reviews_Editedtimes2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đã chỉnh sửa ${i?.count} lần`)
};

const tr_offerdetail_reviews_editedtimes2 = /** @type {(inputs: Offerdetail_Reviews_Editedtimes2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} kez düzenlendi`)
};

const cs_offerdetail_reviews_editedtimes2 = /** @type {(inputs: Offerdetail_Reviews_Editedtimes2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Upraveno ${i?.count}krát`)
};

const bg_offerdetail_reviews_editedtimes2 = /** @type {(inputs: Offerdetail_Reviews_Editedtimes2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Редактирано ${i?.count} пъти`)
};

const ru_offerdetail_reviews_editedtimes2 = /** @type {(inputs: Offerdetail_Reviews_Editedtimes2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Отредактировано ${i?.count} раз(а)`)
};

const uk_offerdetail_reviews_editedtimes2 = /** @type {(inputs: Offerdetail_Reviews_Editedtimes2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Відредаговано ${i?.count} разів`)
};

const ar_offerdetail_reviews_editedtimes2 = /** @type {(inputs: Offerdetail_Reviews_Editedtimes2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`تم التحرير ${i?.count} مرة`)
};

const hi_offerdetail_reviews_editedtimes2 = /** @type {(inputs: Offerdetail_Reviews_Editedtimes2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} बार संपादित`)
};

const th_offerdetail_reviews_editedtimes2 = /** @type {(inputs: Offerdetail_Reviews_Editedtimes2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`แก้ไข ${i?.count} ครั้ง`)
};

const ja_offerdetail_reviews_editedtimes2 = /** @type {(inputs: Offerdetail_Reviews_Editedtimes2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 回編集`)
};

const zh_cn2_offerdetail_reviews_editedtimes2 = /** @type {(inputs: Offerdetail_Reviews_Editedtimes2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`已编辑 ${i?.count} 次`)
};

const zh_hant1_offerdetail_reviews_editedtimes2 = /** @type {(inputs: Offerdetail_Reviews_Editedtimes2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`已編輯 ${i?.count} 次`)
};

const ko_offerdetail_reviews_editedtimes2 = /** @type {(inputs: Offerdetail_Reviews_Editedtimes2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}회 수정됨`)
};

/**
* | output |
* | --- |
* | "Edited {count} times" |
*
* @param {Offerdetail_Reviews_Editedtimes2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_reviews_editedtimes2 = /** @type {((inputs: Offerdetail_Reviews_Editedtimes2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Reviews_Editedtimes2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_reviews_editedtimes2(inputs)
	if (locale === "ms") return ms_offerdetail_reviews_editedtimes2(inputs)
	if (locale === "da") return da_offerdetail_reviews_editedtimes2(inputs)
	if (locale === "de") return de_offerdetail_reviews_editedtimes2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_reviews_editedtimes2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_reviews_editedtimes2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_reviews_editedtimes2(inputs)
	if (locale === "fil") return fil_offerdetail_reviews_editedtimes2(inputs)
	if (locale === "fr") return fr_offerdetail_reviews_editedtimes2(inputs)
	if (locale === "it") return it_offerdetail_reviews_editedtimes2(inputs)
	if (locale === "hu") return hu_offerdetail_reviews_editedtimes2(inputs)
	if (locale === "nl") return nl_offerdetail_reviews_editedtimes2(inputs)
	if (locale === "no") return no_offerdetail_reviews_editedtimes2(inputs)
	if (locale === "pl") return pl_offerdetail_reviews_editedtimes2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_reviews_editedtimes2(inputs)
	if (locale === "pt") return pt_offerdetail_reviews_editedtimes2(inputs)
	if (locale === "ro") return ro_offerdetail_reviews_editedtimes2(inputs)
	if (locale === "fi") return fi_offerdetail_reviews_editedtimes2(inputs)
	if (locale === "sv") return sv_offerdetail_reviews_editedtimes2(inputs)
	if (locale === "vi") return vi_offerdetail_reviews_editedtimes2(inputs)
	if (locale === "tr") return tr_offerdetail_reviews_editedtimes2(inputs)
	if (locale === "cs") return cs_offerdetail_reviews_editedtimes2(inputs)
	if (locale === "bg") return bg_offerdetail_reviews_editedtimes2(inputs)
	if (locale === "ru") return ru_offerdetail_reviews_editedtimes2(inputs)
	if (locale === "uk") return uk_offerdetail_reviews_editedtimes2(inputs)
	if (locale === "ar") return ar_offerdetail_reviews_editedtimes2(inputs)
	if (locale === "hi") return hi_offerdetail_reviews_editedtimes2(inputs)
	if (locale === "th") return th_offerdetail_reviews_editedtimes2(inputs)
	if (locale === "ja") return ja_offerdetail_reviews_editedtimes2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_reviews_editedtimes2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_reviews_editedtimes2(inputs)
	return ko_offerdetail_reviews_editedtimes2(inputs)
});
export { offerdetail_reviews_editedtimes2 as "offerDetail.reviews.editedTimes" }